import moment from "moment";

export const formatStoreDateTime = (value, format = "MMM DD, YYYY, h:mm A") => {
  if (!value) {
    return "";
  }

  const parsed = moment(value);
  if (!parsed.isValid()) {
    return "";
  }

  return parsed.format(format);
};

